<div class="fc-responsive-ag-dialog" #wrapper [ngClass]="modalClasses" role="dialog">
    <ng-template #viewContainer></ng-template>
</div>